import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { cls } from "@iscr/views/NUI/utils";
const BASIC_STYLES = `
<style>
html, body {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
            Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
</style>
`;
export function EmbeddedContent({ html, className, autoHeight, fluid, styled, }) {
    const ref = useRef(null);
    const heightRef = useRef(0);
    useEffect(() => {
        var _a;
        if (!html)
            return;
        const iframe = ref.current;
        if (!iframe)
            return;
        const doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        if (!doc)
            return;
        doc.body.innerHTML = [styled ? BASIC_STYLES : "", html].join("\n");
    }, [html, styled, autoHeight]);
    useEffect(() => {
        var _a;
        if (!autoHeight)
            return;
        const iframe = ref.current;
        if (!iframe)
            return;
        const doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        if (!doc)
            return;
        const resizeObserver = new ResizeObserver(() => {
            const newHeight = doc.documentElement.getBoundingClientRect().height;
            if (heightRef.current !== newHeight) {
                heightRef.current = newHeight;
                iframe.style.height = `${newHeight}px`;
            }
        });
        resizeObserver.observe(doc.body);
        return () => {
            resizeObserver.disconnect();
        };
    }, [autoHeight]);
    if (!html) {
        return null;
    }
    return (_jsx("iframe", { ref: ref, className: cls(fluid && "w-full", className), style: { height: autoHeight ? 0 : undefined } }));
}
